"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RmqProviderType = void 0;
var RmqProviderType;
(function (RmqProviderType) {
    RmqProviderType["WAREHOUSE_SERVICE"] = "WAREHOUSE_SERVICE";
    RmqProviderType["EML_SERVICE"] = "EML_SERVICE";
    RmqProviderType["TPL_SERVICE"] = "TPL_SERVICE";
    RmqProviderType["PDF_SERVICE"] = "PDF_SERVICE";
    RmqProviderType["WEBHOOK_SERVICE"] = "WEBHOOK_SERVICE";
})(RmqProviderType || (exports.RmqProviderType = RmqProviderType = {}));
//# sourceMappingURL=provider.js.map